import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.object.assign.js";
import { getUserEmailPrefix } from './_weblogger';
import { sendImmediatelyCustom } from './weblogerEvent';
var EErrorType = /*#__PURE__*/function (EErrorType) {
  EErrorType["HTTP"] = "HTTP";
  EErrorType["BUSINESS"] = "BUSINESS";
  return EErrorType;
}(EErrorType || {});
var uploadAPIError = function uploadAPIError(options) {
  try {
    sendImmediatelyCustom('web_api_error', options);
  } catch (e) {}
};
function getPubParams() {
  return {
    web_path: location.href.split('?')[0],
    web_params: location.search,
    user_email: getUserEmailPrefix()
  };
}
export var uploadHttpError = function uploadHttpError(options) {
  var params = Object.assign({
    error_type: EErrorType.HTTP
  }, getPubParams(), options);
  uploadAPIError(params);
};
export var uploadBusinessError = function uploadBusinessError(options) {
  var params = Object.assign({
    error_type: EErrorType.BUSINESS
  }, getPubParams(), options);
  uploadAPIError(params);
};